import { NodeElement } from './node-element';

export class NodeDeviceSection extends NodeElement {

}
